import config from '@/config'
import { authenticatedFetch } from '@/helpers/api/httpClient'
import { downloadBase64File } from '@/helpers/downloadBase64File'
import type { DownloadFileResponse } from '@/helpers/api/WebApiClient'

const baseUrl = config.LOCAL_API_URL || config.API_URL || 'https://localhost:7027'

/**
 * Fetches the NIBIRU SQLDBD desktop application installer from the backend (which in turn
 * pulls it from the configured FTP server) and triggers a browser download.
 * Hand-written (not NSwag-generated) since the response is decoded into a binary blob rather than JSON data.
 */
export const downloadSqlDbd = async (): Promise<void> => {
	const response = await authenticatedFetch(`${baseUrl}/api/subscription/subscription/sqldbd`, {
		method: 'GET',
	})

	const data = (await response.json()) as DownloadFileResponse

	const fileName = data.extension ? `${data.name}.${data.extension}` : data.name
	downloadBase64File(data.fileBase64String, fileName)
}
